import React, { useState, useEffect } from 'react';
import { DropdownContainer, DropdownHeader, DropdownList, DropdownItem } from './MenuProductMobile.style';
import { IoIosArrowDown } from "react-icons/io";
import { useParams, useNavigate } from 'react-router-dom';

const MenuProductMobile = ({ productLines = [], lineId }) => {
  const { subCategory } = useParams();
  const navigate = useNavigate();
  const [selected, setSelected] = useState({ name: 'Select Category' });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const currentCategory = productLines.find(item => item.id === subCategory);
    if (currentCategory) {
      setSelected(currentCategory);
    } else if (productLines.length > 0) {
      setSelected(productLines[0]);
    }
  }, [productLines, subCategory]);

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);
    navigate(`/lineas/${lineId}/${item.id}/${item.firstProductId}`);
  };

  return (
    <DropdownContainer>
      <DropdownHeader onClick={() => setIsOpen(!isOpen)}>
        {selected.name} <IoIosArrowDown />
      </DropdownHeader>
      {isOpen && (
        <DropdownList>
          {productLines.map((item) => (
            <DropdownItem key={item.id} onClick={() => handleSelect(item)}>
              {item.name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
}

export default MenuProductMobile
